import React from 'react'
import { ENDPOINT } from '../../services/endPoints';
import CustomDataTable from '../../components/CustomDataTable/CustomDataTable';

const RejectedList = () => {
  const excludedKeys = ['id', 'form_viewed', 'year', 'doctore_comments1', 'doctore_comments2', 'form_filling_Date', 'doctore_comments3', "createdAt", "updatedAt", "deletedAt",
    "patient_DOB", "form_code", "hospital_region", "patient_code", "patient_cmis_id", "facility_type",
    "pf_id", "patient_age", "patient_gender", "nurses_region", "form_accept_reject", "hospital_id",
    "nurses_id"];

  const compareValue = [
    "id",
    "patient_name",
    "patient_age",
    "patient_DOB",
    "patient_gender",
    "patient_natinal_id",
    "patient_cmis_id",
    "patient_code",
    "nurses_id",
    "facility_name",
    "facility_type",
    "hospital_id",
    "hospital_Name",
    "hospital_region",
    "form_accept_reject",
    "doctore_comments1",
    "doctore_comments2",
    "doctore_comments3",
    "form_viewed",
    "form_filling_Date",
    "form_code",
    "form_type",
    "form_risk_rating",
    "createdAt",
    "updatedAt",
    "deletedAt",
    "pf_id",
    "patient_age",
    "patient_gender",
    "nurses_region",
    "nurse_name",
    "form_accept_reject",
  ];

  const customKeyName = {
    "id": "ID",
    "patient_name": "Name",
    "patient_natinal_id": "National ID",
    "nurses_id": "Nurses ID",
    "facility_name": "Facility Name",
    "facility_type": "Facility Type",
    "hospital_id": "Referred Facility ID",
    "hospital_Name": "Referred Facility",
    "hospital_region": "Referred Facility Region",
    "form_accept_reject": "Form Accept Reject",
    "form_viewed": "Form Viewed",
    "form_filling_Date": "Form Filling Date",
    "form_code": "Form Code",
    "form_type": "Form Type",
    "form_risk_rating": "Risk Rating",
    "nurse_name": "Nurse Name",
    "createdAt": "Created",
    "updatedAt": "Updated",
    "deletedAt": "Deleted"
  }

  const customWidth = {
    patient_name: "150px",
    patient_natinal_id: "220px",
  }


  return (
    <>
      <CustomDataTable
        tableTitle={"List of Rejected Test"}
        endPoint={ENDPOINT.DASHBOARD_REJECTEDTEST}
        filterKey={"patient_name"}
        excludedKeys={excludedKeys}
        customKeyName={customKeyName}
        compareValue={compareValue}
        customWidth={customWidth}
      />
    </>
  )
}

export default RejectedList